import { FormValues, getValue, InputFormGroup } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { Fields as TagDetailsFields, TagsEditPanel } from "../../components/TagsEditPanel/TagsEditPanel";
import { useOperation } from "../../hooks/useOperation";
import { OperationActionProps } from "../OperationTypes";
import { MysqlUpdateTagsProps, newMysqlUpdateTags } from "./MysqlUpdateTags";

export interface MysqlEditTagsProps extends OperationActionProps {
  databaseId: string;
  defaultTags?: { name: string; value: string; }[];
}

const MysqlEditTags = (
  { targetId, location, databaseId, defaultTags, onExecute, onCancel }: MysqlEditTagsProps,
): JSX.Element => {
  const { trigger: triggerUpdateTags } = useOperation<MysqlUpdateTagsProps>(newMysqlUpdateTags);

  return (
    <TagsEditPanel
      targetId={targetId}
      title={Messages.labels.editTags()}
      tagsDefaultValue={defaultTags || []}
      onSubmit={(formValues: FormValues) => {
        const tags: { name: string; value: string; }[] = getValue(formValues, TagDetailsFields.Tags, InputFormGroup);
        triggerUpdateTags({
          databaseId,
          tags,
          location,
          onExecute,
        });
      }}
      onClose={onCancel}
    />
  );
};

export const newMysqlEditTags = (
  props: MysqlEditTagsProps,
): JSX.Element => (<MysqlEditTags {...props} />);
